import { Config } from "../../../configurations/config";

export const TotalProjectHoursAPIs = {
	GetAllEmpList: `${Config.server_url}${Config.api_prefix}/Employee/GetAllEmployees`,
	GetSupervisorsEmployeesList: `${Config.server_url}${Config.api_prefix}/Employee/GetSupervisorsEmployeesList`,
	GetTotalProjectHours: `${Config.server_url}${Config.api_prefix}/TimeSheet/TotalProjectHours`,
	ExportToExcel: `${Config.server_url}${Config.api_prefix}/TimeSheet/TotalProjectHours/ExportToExcel`,
};
